// ** Initial State
const initialState = {
  cdg_load_requests: [],
  total_cdg_load_requests: 0,
};

const cdgLoadRequests = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_CDG_LOAD_REQUESTS":
      return { ...state, cdg_load_requests: action.payload };
    case "FETCH_CDG_LOAD_REQUESTS_SUCCESS":
      return { 
        ...state, 
        cdg_load_requests: action.payload.data || action.payload,
        total_cdg_load_requests: action.payload.total || action.payload.length || 0
      };
    case "FETCH_CDG_LOAD_REQUESTS_ERROR":
      return { ...state };
    default:
      return state;
  }
};

export default cdgLoadRequests;
